// Static editorial + business content for Speed Détresse (cahier des charges).

export const IMAGES = {
  hero: "https://images.pexels.com/photos/16703087/pexels-photo-16703087.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  heroAlt: "https://images.unsplash.com/photo-1692119442094-45806e38a35e?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  facade: "https://images.unsplash.com/photo-1609885447210-5901f870df67?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  carnet: "https://images.pexels.com/photos/37605842/pexels-photo-37605842.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  aiNodes: "https://images.pexels.com/photos/17485657/pexels-photo-17485657.png?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  interior: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  interior2: "https://images.pexels.com/photos/8082227/pexels-photo-8082227.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  interior3: "https://images.unsplash.com/photo-1688646953306-5ec93eab8c06?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  technician: "https://images.pexels.com/photos/32497160/pexels-photo-32497160.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  technician2: "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
};

export const MARQUEE = [
  "Carnet de Santé du Logement",
  "État des lieux intelligent",
  "Gérance & suivi",
  "Interventions techniques",
  "Conciergerie Airbnb",
  "QR code logement",
  "Supervision IA",
];

export const AI_ASSISTANTS = [
  {
    id: "gael",
    name: "Gaël",
    role: "Assistant administratif & opérationnel",
    tagline: "Il organise les demandes et garde le cap sur l'activité.",
    points: [
      "Organise les demandes et génère les alertes utiles",
      "Suit l'activité et les performances",
      "Recherche le professionnel le plus pertinent : zone, spécialité, disponibilités",
      "Assiste le dirigeant au quotidien",
    ],
  },
  {
    id: "jetheque",
    name: "Jéthèque",
    role: "Assistante technicienne",
    tagline: "Elle prépare l'intervention avant même l'arrivée du technicien.",
    points: [
      "Aide à identifier une panne probable à partir des photos et vidéos du client",
      "Reconnaît certains matériaux et équipements",
      "Prépare l'intervention et propose les travaux nécessaires",
      "Contribue à la préparation du devis — la décision finale reste au professionnel",
    ],
  },
  {
    id: "orion",
    name: "Orion",
    role: "Assistant commercial",
    tagline: "Il accompagne la relation client de bout en bout.",
    points: [
      "Accompagne prospects, clients et relances",
      "Organise les rendez-vous",
      "Suit les objectifs et les statistiques commerciales",
    ],
  },
  {
    id: "jarvis",
    name: "Jarvis",
    role: "Assistant développement",
    tagline: "Il veille sur la plateforme elle-même.",
    points: [
      "Assiste la partie technique de la plateforme Speed Détresse",
      "Participe au développement et à l'amélioration continue",
      "Maintient la cohérence du système",
    ],
  },
];

export const PERSONAS = [
  {
    id: "proprietaire",
    label: "Propriétaire",
    title: "Gérez vos biens sans courir après chaque incident",
    image: IMAGES.interior2,
    intro:
      "Un tableau de bord unique pour retrouver vos logements, leurs informations, les interventions, les photos, les documents et les états des lieux. Vous comprenez ce qui se passe, validez une intervention et suivez la résolution, même à distance.",
    features: [
      "Carnet de Santé & carnet d'entretien",
      "Historique complet des interventions",
      "États des lieux d'entrée et de sortie",
      "Équipements, échéances et QR code du logement",
      "Gestion des locataires et des incidents",
      "Photos et documents centralisés",
    ],
    cta: { label: "Demander mon abonnement", to: "/souscription" },
  },
  {
    id: "locataire",
    label: "Locataire",
    title: "Déclarer devient simple, même quand on ne sait pas quoi faire",
    image: IMAGES.interior3,
    intro:
      "Fuite, panne, problème technique : décrivez la situation, ajoutez des photos, indiquez l'urgence. Votre signalement est ensuite orienté vers le bon interlocuteur.",
    features: [
      "Signalement de fuite, panne ou accident",
      "Photos et vidéos jointes",
      "Niveau d'urgence et description guidée",
      "Suivi transparent de la demande",
    ],
    cta: { label: "Signaler un incident", to: "/contact" },
  },
  {
    id: "airbnb",
    label: "Airbnb",
    title: "Faciliter l'accès aux informations du logement",
    image: IMAGES.interior,
    intro:
      "Grâce au QR code permanent associé au logement, l'occupant accède aux informations qui lui sont destinées — et le QR code continue de fonctionner même lorsque les informations évoluent.",
    features: [
      "QR code permanent du logement",
      "Accès voyageur & consignes",
      "Informations utiles et assistance",
      "Signalement d'incidents intégré",
    ],
    cta: { label: "Découvrir la conciergerie", to: "/souscription" },
  },
  {
    id: "technicien",
    label: "Technicien",
    title: "Plus de temps sur le terrain. Moins d'administratif.",
    image: IMAGES.technician,
    intro:
      "Interventions, adresses, demandes, photos, comptes-rendus, pièces nécessaires, historique, gains : l'IA prépare la tournée et accompagne le professionnel sans remplacer son expertise.",
    features: [
      "Diagnostic assisté par l'IA Jéthèque",
      "Reconnaissance d'équipements par photo",
      "Rapports d'intervention préparés",
      "Historique et suivi des interventions",
    ],
    cta: { label: "Rejoindre nos techniciens", to: "/rejoindre" },
  },
];

export const CARNET_ITEMS = [
  "États des lieux d'entrée et de sortie",
  "Photos et historique visuel du bien",
  "Travaux, réparations et interventions",
  "Chaudière, électricité, détecteurs, VMC, climatisation",
  "Dates de maintenance et prochaines échéances",
  "Documents, rapports et garanties",
  "Comparaison de l'évolution du logement",
];

export const ETAT_CATEGORIES = [
  { zone: "Pièces", items: ["Entrée", "Salon", "Cuisine", "Chambres", "Salle de bains", "WC", "Couloirs"] },
  { zone: "Annexes", items: ["Escaliers", "Balcons", "Terrasses", "Caves", "Garages", "Annexes"] },
  { zone: "Surfaces", items: ["Sols", "Murs", "Plafonds"] },
  { zone: "Ouvertures", items: ["Fenêtres", "Volets", "Portes", "Poignées", "Serrures"] },
  { zone: "Équipements", items: ["Placards", "Radiateurs & chauffage", "Électroménager", "Sanitaires & ventilation", "Prises & éclairage"] },
];

export const PRESTATIONS = [
  { title: "État des lieux d'entrée", desc: "État des lieux numérique : photos, observations, rapport et archivage.", tarif: "Sur devis" },
  { title: "État des lieux de sortie", desc: "Contrôle de sortie et comparaison fidèle avec l'état précédent.", tarif: "Sur devis" },
  { title: "Intervention technique", desc: "Qualification de la demande puis organisation avec un professionnel adapté.", tarif: "Sur devis" },
  { title: "Rénovation & travaux lourds", desc: "Étude du besoin et devis dédié selon le chantier.", tarif: "Sur devis" },
];

export const PRESTATION_NOTE =
  "Panier moyen indicatif d'une prestation ponctuelle : environ 130 €. Ce repère ne remplace pas le devis réel — le prix dépend du métier, de la complexité, du déplacement, de l'urgence, des fournitures et du temps nécessaire.";

export const CLIENT_TYPES = [
  "Propriétaire occupant",
  "Bailleur",
  "SCI",
  "Gestionnaire",
  "Airbnb / location saisonnière",
  "Professionnel",
];

export const SERVICES = [
  "Abonnement Carnet de Santé",
  "État des lieux",
  "Interventions techniques",
  "Conciergerie Airbnb",
  "Gérance",
];

export const RECRUITMENT_POSTES = [
  "Technicien",
  "Commercial",
  "Apporteur d'affaires",
  "Administratif",
  "Partenaire",
  "Candidature spontanée",
  "Autre",
];

export const WHY_CHOOSE = [
  "Le dépannage et les prestations techniques",
  "La gestion des logements",
  "Le réseau d'artisans",
  "Les états des lieux numériques",
  "Le QR code logement",
  "Les outils pour propriétaires et bailleurs",
  "Les tableaux de bord professionnels",
  "L'intelligence artificielle",
  "Le suivi des interventions et des documents",
];

export const ENGAGEMENTS = [
  "Prise en charge immédiate de la demande",
  "Artisans vérifiés (Kbis + assurances décennales)",
  "Devis transparents et signés électroniquement",
  "PV de réception électronique avec signature client",
  "Paiement sécurisé bloqué jusqu'à validation",
  "Garantie 48h sur toutes les interventions",
];

export const PLATFORM_CAPABILITIES = [
  "Gérer un ou plusieurs logements",
  "Suivre les travaux, réparations et interventions",
  "Conserver un historique complet",
  "Réaliser et archiver des états des lieux numériques",
  "Utiliser un QR code associé au logement",
  "Déclarer un incident avec photos ou vidéos",
  "Préparer une intervention avec l'aide de l'IA",
  "Faciliter les échanges entre utilisateurs et professionnels",
  "Suivre la satisfaction et la qualité des interventions",
];

export const ARTISAN_FORMULES = [
  { name: "Gratuit", desc: "Diagnostic IA, 3 photos analysées/mois, marketplace." },
  { name: "Standard", desc: "20 photos/mois, états des lieux, QR code logement." },
  { name: "Premium", desc: "Photos illimitées, assistant vocal, formation accompagnée par l'IA Jéthèque." },
  { name: "Gold", desc: "Toutes les fonctions Premium, orienté volume." },
  { name: "Artisan Pro", desc: "Devis & métré assistés par l'IA, l'offre la plus complète." },
];

export const FAQ = [
  {
    q: "Quelle est la différence entre le site et l'application ?",
    a: "Le site informe, convainc et collecte vos demandes. L'application est le centre opérationnel qui traite, suit et exécute chaque dossier. Une demande faite ici crée automatiquement un dossier côté application.",
  },
  {
    q: "Comment fonctionne la tarification ?",
    a: "L'abonnement est calculé au m² avec une dégressivité selon le nombre de logements, de 0,85 €/m²/mois à 0,50 €/m²/mois. Au-delà de 110 logements, c'est sur devis. Un logement = un abonnement.",
  },
  {
    q: "Qu'est-ce que le Carnet de Santé du Logement ?",
    a: "C'est la mémoire numérique permanente de votre bien : états des lieux, photos, interventions, équipements, échéances de maintenance, documents et garanties, avec comparaison dans le temps.",
  },
  {
    q: "Puis-je déposer mon CV pour rejoindre Speed Détresse ?",
    a: "Oui. Le formulaire de recrutement permet de postuler (technicien, commercial, apporteur d'affaires, administratif…) et de joindre votre CV. Votre candidature arrive directement dans l'espace recrutement.",
  },
  {
    q: "Mes données sont-elles protégées ?",
    a: "Oui. Les échanges sont sécurisés, les droits d'accès contrôlés et les consentements recueillis. Aucune décision sensible n'est automatisée sans règle de validation humaine.",
  },
];

export const ARTICLES = [
  {
    slug: "5-echeances-entretien-logement",
    tag: "Entretien",
    title: "5 échéances de maintenance à ne jamais oublier",
    read: "4 min",
    excerpt: "Chaudière, VMC, détecteurs… un calendrier simple pour garder un logement sain toute l'année.",
    content: [
      "Un logement bien suivi est un logement qui coûte moins cher sur la durée. Certaines opérations d'entretien reviennent chaque année et sont faciles à oublier lorsqu'elles ne sont pas notées quelque part.",
      "1. L'entretien annuel de la chaudière est obligatoire pour les chaudières au gaz, au fioul ou au bois. Il garantit la sécurité, la performance et prolonge la durée de vie de l'appareil.",
      "2. La ventilation (VMC) doit être nettoyée régulièrement : des bouches encrassées dégradent la qualité de l'air et favorisent l'humidité.",
      "3. Les détecteurs de fumée se testent régulièrement et leur pile se remplace avant qu'elle ne faiblisse.",
      "4. Les joints de salle de bains et de cuisine se contrôlent pour éviter les infiltrations discrètes qui abîment les supports.",
      "5. La robinetterie et les évacuations méritent un contrôle pour repérer tôt une petite fuite avant qu'elle ne devienne un dégât.",
      "Avec le Carnet d'entretien Speed Détresse, ces échéances sont conservées au même endroit, avec leurs dates et leurs rappels : rien ne se perd, tout se suit.",
    ],
  },
  {
    slug: "reussir-etat-des-lieux",
    tag: "État des lieux",
    title: "Réussir un état des lieux qui protège tout le monde",
    read: "6 min",
    excerpt: "Photos reliées à chaque élément, rapport signé et comparaison de sortie : la méthode pour éviter les litiges.",
    content: [
      "L'état des lieux est le document qui protège à la fois le propriétaire et le locataire. Un état des lieux flou ou incomplet est la première source de litige en fin de location.",
      "La clé, c'est la précision : chaque pièce est passée en revue, du sol au plafond, en passant par les ouvertures, les équipements et les prises. Une photo reliée à chaque élément vaut mieux qu'une longue description.",
      "À l'entrée, on documente l'état réel du logement. À la sortie, on compare point par point avec l'état d'entrée : c'est cette comparaison fidèle qui permet de trancher sereinement.",
      "L'état des lieux intelligent de Speed Détresse guide le contrôle pièce par pièce, associe les photos aux bons éléments et archive un rapport signé, comparé automatiquement au précédent.",
    ],
  },
  {
    slug: "louer-sereinement-amiens",
    tag: "Amiens",
    title: "Louer sereinement dans le secteur d'Amiens",
    read: "5 min",
    excerpt: "Marché local, attentes des locataires et bons réflexes pour gérer un bien à Amiens et ses environs.",
    content: [
      "Amiens et sa périphérie offrent un marché locatif dynamique, porté notamment par la vie étudiante et les actifs. Pour un propriétaire, la sérénité passe par une bonne organisation dès le départ.",
      "Un logement documenté rassure : historique d'entretien clair, équipements connus, interventions tracées. C'est un argument de confiance au moment de louer comme de vendre.",
      "La réactivité en cas d'incident fait la différence. Pouvoir signaler une fuite ou une panne en quelques secondes, photos à l'appui, évite l'aggravation et les tensions.",
      "Speed Détresse intervient sur Amiens et son secteur : suivi des logements, états des lieux, interventions qualifiées et mémoire numérique du bien réunis au même endroit.",
    ],
  },
];

export const STATUS_LABELS = {
  nouveau: "Nouveau",
  prelancement: "Nouveau — pré-lancement",
  a_recontacter: "À recontacter",
  presentation: "Présentation à organiser",
  offre_a_preciser: "Offre à préciser",
  a_traiter: "À traiter",
  en_cours: "En cours",
  rendez_vous: "Rendez-vous",
  accepte: "Accepté",
  app_ouverte: "Application ouverte",
  refuse: "Refusé",
  termine: "Terminé",
  archive: "Archivé",
};

export const KIND_LABELS = {
  subscription: "Abonnement",
  appointment: "Rendez-vous",
  recruitment: "Recrutement",
  partner: "Apporteur d'affaires",
  contact: "Contact",
  estimate: "Estimation",
  visit: "Visite",
  notify: "Ouverture (waitlist)",
};

export const NOTIFY_PROFILS = ["Particulier", "Propriétaire", "Bailleur", "Agence", "Airbnb", "Artisan", "Technicien", "Entreprise", "Autre"];

export const AD_SLOTS = [
  {
    partner: "Crédit Habitat +",
    baseline: "Financez votre projet immobilier à taux avantageux",
    cta: "Simuler mon prêt",
    tone: "from-amber-500/20 to-amber-700/10",
  },
  {
    partner: "Notaires du Nord",
    baseline: "Accompagnement juridique pour vos achats & ventes",
    cta: "Prendre rendez-vous",
    tone: "from-sky-500/20 to-sky-700/10",
  },
  {
    partner: "Déménix Pro",
    baseline: "Déménagement clé en main dans le secteur d'Amiens",
    cta: "Obtenir un devis",
    tone: "from-emerald-500/20 to-emerald-700/10",
  },
];

export const PROPERTY_TYPES = ["Appartement", "Maison", "Studio", "Terrain", "Local commercial", "Parking"];

export const METIERS = [
  { id: "plomberie", label: "Plomberie", desc: "Fuites, sanitaires, robinetterie, réseaux d'eau.", available: true },
  { id: "electricite", label: "Électricité", desc: "Tableaux, prises, éclairage, mise aux normes.", available: true },
  { id: "chauffage", label: "Chauffage", desc: "Chaudières, radiateurs, entretien et dépannage.", available: true },
  { id: "ventilation", label: "Ventilation", desc: "VMC, aération, qualité de l'air intérieur.", available: true },
  { id: "climatisation", label: "Climatisation", desc: "Pose, entretien et contrôle des systèmes.", available: true },
  { id: "serrurerie", label: "Serrurerie", desc: "Serrures, cylindres, ouvertures et sécurité.", available: true },
  { id: "menuiserie", label: "Menuiserie", desc: "Portes, fenêtres, volets, ajustements bois.", available: true },
  { id: "petits-travaux", label: "Petits travaux", desc: "Réparations diverses et finitions.", available: true },
  { id: "entretien", label: "Entretien", desc: "Maintenance régulière et suivi des équipements.", available: true },
];

export const CARNET_ENTRETIEN = [
  "Opérations d'entretien réalisées",
  "Maintenances à prévoir",
  "Équipements concernés (chaudière, VMC, détecteurs…)",
  "Dates et prochaines échéances",
  "Rappels et planification du suivi régulier",
];
